import { authApi } from './authApi';
import { DashboardSummaryResponse } from '../types/dashboard';

/**
 * Obtém o resumo da dashboard (ex.: Connect).
 * GET /dashboard/summary
 */
export const getDashboardSummary = async (): Promise<DashboardSummaryResponse> => {
  const response = await authApi.get<DashboardSummaryResponse>('/dashboard/summary');
  return response.data;
};
